import { Flex, Form, Typography } from 'antd';
import { t } from 'i18next';
import { useSelector } from 'react-redux';

import { useNotification } from 'segments/hooks';

import { SubmiteButton, HoursSelector } from 'shared/FormItems';

import { useUpdateWorkTimeMutation, selectWorkTime, WorkTime as WorkTimeType } from 'features/config';

type FormData = WorkTimeType;

export const WorkTime = () => {
  const [form] = Form.useForm<FormData>();
  const [update, { isSuccess, isError, isLoading: isUpdateLoading, error }] = useUpdateWorkTimeMutation();
  const serverWorkTime = useSelector(selectWorkTime);

  const onFinish = (values: FormData) => {
    update(values);
  };


  useNotification({
    error,
    isSuccess,
    isError,
  });

  return (
    <div>
      <Flex align="center" justify="space-between">
        <Typography.Title level={2}>{t('pages.work-time')}</Typography.Title>
      </Flex>

      <Form
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        name="basic"
        layout="vertical"
        initialValues={serverWorkTime}
        style={{ maxWidth: '600px' }}
      >
        <HoursSelector
          from={0}
          to={23}
          formProps={{
            name: 'open',
            label: t('form-items.select.time-space.start'),
            rules: [
              {
                validator: (_, value) =>
                  !value || value < form.getFieldValue('closed')
                    ? Promise.resolve()
                    : Promise.reject(
                      new Error('The opening time must be earlier than the closing time.')
                    )
              },
            ],
          }}
        />

        <HoursSelector
          from={0}
          to={23}
          formProps={{
            name: 'closed',
            label: t('form-items.select.time-space.end'),
            rules: [
              {
                validator: (_, value) =>
                  !value || value > form.getFieldValue('open')
                    ? Promise.resolve()
                    : Promise.reject(
                      new Error('The closing time must be later than the opening time.')
                    )
              },
            ],
          }}
        />
        <SubmiteButton isLoading={isUpdateLoading} />
      </Form>
    </div >
  );
};
